import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  brand: Yup.string().required(),
  price: Yup.number().required(),
});

export default function AddProductForm({
  onAddDealerProduct,
  brandsAvailableToAdd,
  onHideAddProductForm,
  children,
}) {
  return (
    <Formik
      initialValues={{ brand: brandsAvailableToAdd[0], price: 0 }}
      validationSchema={validationSchema}
      validateOnBlur={false}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        onAddDealerProduct(values)
          .then(() => {
            setSubmitting(false);
            onHideAddProductForm();
          })
          .catch(e => {
            console.log(e);
            setSubmitting(false);
            setErrors({ general: <FormattedMessage id="generic_error_message" /> });
          });
      }}
    >
      {formikProps => {
        return <Form>{children(formikProps)}</Form>;
      }}
    </Formik>
  );
}

AddProductForm.defaultProps = {
  children: Function.prototype,
};
AddProductForm.propTypes = {
  onAddDealerProduct: PropTypes.func.isRequired,
  onHideAddProductForm: PropTypes.func.isRequired,
  brandsAvailableToAdd: PropTypes.array.isRequired,
  children: PropTypes.func,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsAddProductForm/AddProductForm/AddProductForm.jsx